import { TableCellType } from "@/constants/table/table";
import { Organization } from "@/types/organizations";
import { ColumnDef } from "@tanstack/react-table"

export const defaultColumns: ColumnDef<Organization>[] = [
  {
    accessorKey: "name",
    header: "Name",
    meta: { type: TableCellType.LINK_BUTTON },
  },
  {
    accessorKey: "allWorkflowCount",
    header: "Total Workflows",
    meta: { type: TableCellType.NUMBER },
  },
  {
    accessorKey: "allWorkflowExecutionCount",
    header: "Total Workflow Executions",
    meta: { type: TableCellType.NUMBER },
  },
  {
    accessorKey: "action",
    header: "Actions",
    meta: { type: TableCellType.ACTION_BUTTON },
  },
]

export const activeOnlyColumns: ColumnDef<Organization>[] = [
  {
    accessorKey: "name",
    header: "Name",
    meta: { type: TableCellType.LINK_BUTTON },
  },
  {
    accessorKey: "activeWorkflowCount",
    header: "Active Workflows",
    meta: { type: TableCellType.NUMBER },
  },
  {
    accessorKey: "activeWorkflowExecutionCount",
    header: "Active Workflow Executions",
    meta: { type: TableCellType.NUMBER },
  },
  {
    accessorKey: "action",
    header: "Actions",
    meta: { type: TableCellType.ACTION_BUTTON },
  }
]
